import React, { useState, useEffect } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import "./css/HomeGallery.css"
const galleryImages = [
  {
    title: "Masai Mara National Park",
    src: require("../assets/image/8.jpg")
  },
  {
    title: "Diani Beach",
    src: require("../assets/image/mombasa_expendition_safari_explore.jpg")
  },
  {
    title: "Diani Beach",
    src: require("../assets/image/16.jpg")
  },
  {
    title: "Lake Naivasha",
    src: require("../assets/image/3.jpg")
  },
  {
    title: "Nairobi City",
    src: require("../assets/image/17.jpg")
  },
  {
    title: "Tsavo National Park",
    src: require("../assets/image/18.jpg")
  }
];

export default function Gallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Handle Esc key close
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      if (e.key === "Escape") setLightboxOpen(false);
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  });

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <section className="gallery-section container" style={{marginBottom: "90px"}}>
      <div className="home-title">
        <h2>Photo Gallery</h2>
        <p>Check Out</p>
      </div>
      <div className="gallery-grid">
        {galleryImages.map((img, index) => (
          <div key={index} className="gallery-item" onClick={() => openLightbox(index)}>
            <LazyLoadImage
                alt={img.title}
                src={img.src}
                effect="blur"
              />
            <div className="gallery-overlay">
              <span></span>
            </div>
          </div>
        ))}
      </div>

      {lightboxOpen && (
        <div className="lightbox">
          <button className="close-btn" onClick={closeLightbox}>&times;</button>
          <button className="prev-btn" onClick={prevImage}>&#10094;</button>
          <img src={galleryImages[currentIndex].src} alt={galleryImages[currentIndex].title} />
          <button className="next-btn" onClick={nextImage}>&#10095;</button>
          <div className="lightbox-caption"></div>
        </div>
        
      )}
      <a href="gallery" className="btn-medium" style={{float:'right', marginTop: "20px"}}>View More</a>
    </section>
  );
}
